
































import _ from "lodash";
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Mixins
} from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Role from "@/store/entities/role";
import RoleTreeMixin from "./roleTree";

@Component
export default class EditRole extends Mixins(AbpBase, RoleTreeMixin) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  role: Role = new Role();
  get permissions() {
    return this.$store.state.role.permissions;
  }

  get rolePermissions() {
    return this.role.permissions;
  }

  treeData = [];
  selectedNodes = [];

  save() {
    (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
        const nodes = (this.$refs[
          "tree"
        ] as any).getCheckedAndIndeterminateNodes();
        const selectedPermissions = _.map(nodes, n => n.key);
        this.role.permissions = selectedPermissions;
        await this.$store.dispatch({
          type: "role/update",
          data: this.role
        });
        (this.$refs.roleForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.role = Util.extend(true, {}, this.$store.state.role.editRole);
      this.selectedNodes = [];
      this.treeData = this.initTree(_.map(this.permissions, p => p.name));
    }
  }

  updateSelectedNodes() {
    this.selectedNodes = _.map(
      (this.$refs["tree"] as any).getCheckedNodes(),
      "key"
    );
  }

  revertCheck(items) {
    _.forEach(items, tree => {
      if (_.includes(this.selectedNodes, tree.key)) {
        tree.checked = true;
      } else {
        tree.checked = false;
      }
      if (!_.isEmpty(tree.children)) {
        this.revertCheck(tree.children);
      }
    });
  }

  onCheckChange(list, selected) {
    if (!_.isEmpty(selected.children)) {
      this.$Modal.confirm({
        title: "Xác nhận",
        content: `Bạn có chắc muốn ${
          selected.checked ? "chọn" : "bỏ chọn"
        } quyền ${selected.title}`,
        okText: this.L("Yes"),
        cancelText: this.L("No"),
        onOk: () => {
          this.updateSelectedNodes();
        },
        onCancel: () => {
          this.revertCheck(this.treeData);
        }
      });
    } else {
      this.updateSelectedNodes();
    }
  }
  roleRule = {
    displayName: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("DisplayName")
        ),
        trigger: "blur"
      }
    ]
  };
}
